export default __webpack_public_path__ + "static/media/Path 157.64992dd6.svg";